/**
 * 环境配置代码
 */
const environment = (function () {
  // 判断是否生产环境
  const isPro = /^(https?:\/\/)?(gsc(hk|eu|us)?\.midea\.com)(\/|$)/.test(location.hostname);

  // 各系统应用名
  const _application = {
    mframework: '/mframework',
  };
  // 4A权限配置
  const _auth = {
    defaultReloginUrl: 'http://oamuat.midea.com:12580/mip/mse.html', // 自定义4A登录后返回的页面
    SinglePointLogin: 'http://oamuat.midea.com/sso-service/CleanupCookie?app=', // 4A返回地址
  };
  // 项目目录
  const _pathName = '/#';

  return {
    isPro,
    securityKey: 'mideatest_sso_token', // 'mip_sso_dev_id',//前端秘钥
    index1: 'gscierp.html', // 登录后跳转的系统
    index2: 'gsc.html', // 登录后跳转的系统
    appId: 'SRM_SUPER',
    fname: 'GSC',
    systemAppId: '6b26dda3c98b4840bf4c57a74b9a723b',
    // 基础框架配置
    mframework: {
      pathName: _pathName,
      APPLICATION_NAME: _application.mframework,
      defaultReloginUrl: _auth.defaultReloginUrl, // 自定义4A登录后返回的页面
      SinglePointLogin: _auth.SinglePointLogin, // 4A返回地址
    },
    appName: '/gscapp',
    mPrint: {
      // printJsUrl: 'http://10.17.146.197:12580/mideaPrint/resources/mPrint.js'，
      // printJsUrl: '//mprint.midea.com/mideaPrint/resources/mPrintHttps.js', // 旧打印api
      // printJsUrl: 'http://mprint.midea.com/mideaPrint/resources/mPrint.js'
      printJsUrl: 'static/js/mPrintHttps.js',
    },
    taskIntervalTime: 3 * 60 * 1000,
    appSecrect: '51rs21c-hf03-17m3-ng00-1v4gnb89jh12',
    bigDataOpen: true,
  };
}());

window.environment = environment;
